import $ from 'jquery';
import {TweenMax, Power2, TimelineLite, Linear, Power4, Power0} from "gsap";

function Slider3Cards(selector, slides) {
  this.elems = {};
  this.elems.root = $(selector);
  this.elems.arrowLeft = null;
  this.elems.arrowRight = null;
  this.elems.slidesContent = null;
  this.elems.slides = [];
  this.slides = slides;

  this.iterator = {
    current: 0,
    max: this.slides.length - 1,
    stepSize: 3,
    slideSize: 360,
  };

  let ww = $(window).width();
  if(ww < 600) {
    let condHeight = ww - 40 > 320 ? 320 : ww - 40;
    this.iterator.slideSize = condHeight;
    this.iterator.stepSize = 1;
    this.elems.root.css('height', condHeight);
  } else if(ww < 695) {
    this.iterator.slideSize = 250;
    this.iterator.stepSize = 2;
    this.elems.root.css('height', '250px');
  } else if(ww < 800) {
    this.iterator.slideSize = 300;
    this.iterator.stepSize = 2;
    this.elems.root.css('height', '300px');
  } else if(ww < 950) {
    this.iterator.slideSize = 230;
    this.elems.root.css('height', '230px');
  } else if(ww < 1070) {
    this.elems.root.css('height', '280px');
    this.iterator.slideSize = 280;
  } else if(ww < 1300) {
    this.elems.root.css('height', '300px');
    this.iterator.slideSize = 300;
  } else {
    this.elems.root.css('height', '430px');
    this.iterator.slideSize = 410;
  }

  this.elems.root.html('').show();
  
  // this.makeArrows();
  this.makeSlides();
}

Slider3Cards.prototype.makeArrows = function() {
  this.elems.arrowLeft = $('<button class="slider-3cards-arrow slider-arrow left"></button>');
  this.elems.arrowRight = $('<button class="slider-3cards-arrow slider-arrow right"></button>');

  this.elems.root.append(this.elems.arrowLeft);
  this.elems.root.append(this.elems.arrowRight);

  this.elems.arrowLeft.addClass('disabled');

  if(this.slides.length <= 3) {
    this.elems.arrowRight.addClass('disabled');
  }

  this.bindArrows();
};

Slider3Cards.prototype.bindArrows = function() {
  this.elems.arrowLeft.click(() => {
    this.openSlide(this.iterator.current - this.iterator.stepSize);
  });

  this.elems.arrowRight.click(() => {
    this.openSlide(this.iterator.current + this.iterator.stepSize);
  });
};

Slider3Cards.prototype.openSlide = function(index) {
  if(index < 0) {
    index = 0;
  }
  if(index > this.iterator.max - this.iterator.stepSize) {
    index = this.iterator.max - this.iterator.stepSize;
  }
  this.iterator.current = index;

  if(this.iterator.current <= 0) {
    this.elems.arrowLeft.addClass('disabled');
  } else {
    this.elems.arrowLeft.removeClass('disabled');
  }

  if(this.iterator.current >= this.iterator.max - this.iterator.stepSize) {
    this.elems.arrowRight.addClass('disabled');
  } else {
    this.elems.arrowRight.removeClass('disabled');
  }

  this.renderSlides();
};

Slider3Cards.prototype.makeSlides = function() {
  this.elems.slidesContent = $('<div class="slider-3cards-content"></div>');

  this.elems.root.append(this.elems.slidesContent);

  for(let i=0; i<this.slides.length; i++) {
    this.makeSlide(i, this.slides[i]);
  }

  this.renderSlides();
};

Slider3Cards.prototype.makeSlide = function(index, slide) {
  let slideElem = $('<a href="' + slide.link + '" target="_blank" class="slider-3cards-slide foto_instagram"></a>');
  this.elems.slidesContent.append(slideElem);
  this.elems.slides.push(slideElem);

  slideElem.css({
    // 'left': (index * 100 / 3) + '%',
    'width': this.iterator.slideSize + 'px',
    'height': this.iterator.slideSize + 'px',
    'backgroundImage': 'url("' + slide.thumbnail + '")'
  });

  slideElem.attr('title', slide.title);

  // console.log('MakeSlide ', index, slide);
};

Slider3Cards.prototype.renderSlides = function() {
  for(let i=0; i<this.elems.slides.length; i++) {
    TweenMax.to(this.elems.slides[i], .5, {
      // left: ((i - this.iterator.current) * 100 / this.iterator.stepSize) + '%'
      left: this.calcLeft(i),
    });
  }
};

Slider3Cards.prototype.calcLeft = function(index) {
  // let winWidth = $(window).width();
  let conWidth = this.elems.slidesContent.width();
  let sliWidth = this.iterator.slideSize;

  // let midPoint = conWidth / 2;
  let spacing = (conWidth - (sliWidth * this.iterator.stepSize)) / (this.iterator.stepSize - 1 || 1);

  // let midPos = midPoint - (sliWidth / 2);

  let currIndex = index - this.iterator.current;

  if(this.iterator.stepSize === 1) {
    spacing = 0;
    return (currIndex * spacing) + (currIndex * sliWidth) + spacing / 2;
  }

  return (currIndex * spacing) + (currIndex * sliWidth);
};

export default function(selector, slides) {
  return new Slider3Cards(selector, slides);
};
